import axios from '@/utils/request'

const ApiUrl = '/admin_api/v1/bill/cash_out'

export function getCashOutList(params) {
  return axios.get(`${ApiUrl}/list/`, {
    params
  })
}

export function cashOut(id, data) {
  return axios.post(`${ApiUrl}/${id}/handle/`, data)
}

/**
 * @description: 系统自动打款确认
 * @return {*}
 */
export function cashOutAuto(id, data) {
  return axios.post(`${ApiUrl}/${id}/auto_handle/`, data)
}

/**
 * @description: 批量打款
 * @return {*}
 */

export function cashOutBatch(data) {
  return axios.post(`${ApiUrl}/batch_auto_handle/`, data)
}
